// Chat API szolgáltatás a Yii2 backend-del való kommunikációhoz

const CHAT_API_BASE_URL = process.env.REACT_APP_CHAT_API_URL;
class ChatAPIService {
  constructor() {
    this.baseURL = CHAT_API_BASE_URL;
    this.clientUserId = null; // Frontend user ID

  

    if (!this.baseURL) {
      console.error('REACT_APP_CHAT_API_URL environment variable is not set');
    }
  }

  // Frontend user ID beállítása
  setClientUserId(userId) {
    this.clientUserId = userId;
  }

  // Általános API hívás wrapper hibakezeléssel
  async apiCall(endpoint, options = {}) {
    try {
      if (!this.baseURL) {
        throw new Error('API base URL is not configured');
      }

      const url = `${this.baseURL}${endpoint}`;

      // Build headers
      const headers = {
        'Content-Type': 'application/json',
        ...options.headers
      };

      // Add X-Client-User-ID header if set
      if (this.clientUserId) {
        headers['X-Client-User-ID'] = this.clientUserId.toString();
      } else {
        // Authentication required - client user ID not set
        throw new Error('Authentication required: Client User ID not set. Please login.');
      }

      const config = {
        headers,
        ...options
      };

   
      const response = await fetch(url, config);



      // Check if response is JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        // Log response text for debugging
        const responseText = await response.text();
        console.error('Non-JSON response:', responseText.substring(0, 500));
        throw new Error(`Server returned non-JSON response (${response.status}). Backend may not be running.`);
      }

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      if (!data.success) {
        throw new Error(data.message || 'API hívás sikertelen');
      }

      return data.data;
    } catch (error) {
      console.error('API hívás hiba:', error);
      throw error;
    }
  }

  // Chat létrehozása
  async createChat(chatData) {
    return await this.apiCall('/create-chat', {
      method: 'POST',
      body: JSON.stringify({
        name: chatData.name,
        description: chatData.desc || '',
        created_by: chatData.created_by,
        users: chatData.users
      })
    });
  }

  // Felhasználó chatjeinek lekérése
  async getChats(userId) {
    return await this.apiCall(`/get-chats?user_id=${userId}`);
  }

  // Chat részletek lekérése
  async getChatDetails(chatId, userId) {
    return await this.apiCall(`/get-chat-details?chat_id=${chatId}&user_id=${userId}`);
  }

  // Chat üzeneteinek lekérése
  async getMessages(chatId, userId, limit = 50, offset = 0, markAsRead = true) {
    return await this.apiCall(`/get-messages?chat_id=${chatId}&user_id=${userId}&limit=${limit}&offset=${offset}&mark_as_read=${markAsRead}`);
  }

  // Üzenet küldése
  async sendMessage(messageData) {
    return await this.apiCall('/send-message', {
      method: 'POST',
      body: JSON.stringify({
        chat_id: messageData.chat_id,
        user_id: messageData.user_id,
        message: messageData.message,
        message_type: messageData.message_type || 'text'
      })
    });
  }

  // Felhasználók lekérése
  async getClientUsers() {
    return await this.apiCall('/get-client-users');
  }
}

// Singleton instance
const chatAPI = new ChatAPIService();

export default chatAPI;
